var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-field-tree-node" },
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("i", {
              staticClass: "iconfont icon-biaodanzujian-shurukuang",
              staticStyle: { "margin-right": "5px" },
            }),
            _c("span", [_vm._v(_vm._s(_vm.data.label))]),
          ]
        },
        null,
        { node: _vm.node, data: _vm.data }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }